// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ty-2";
export var container = "_ty-4";
export var dismissButton = "_ty-3";
export var hasPaddingBottom = "_ty-6";
export var last = "_ty-e";
export var scrollbarThumb = "_ty-c";
export var scrollbarTrack = "_ty-b";
export var selected = "_ty-9";
export var spin = "_ty-1";
export var spinning = "_ty-0";
export var suggestionItem = "_ty-d";
export var suggestionsPanel = "_ty-5";
export var tonePill = "_ty-8";
export var tonesContainer = "_ty-7";
export var unselected = "_ty-a";